<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    .grid
      .column.is-widescreen-5.is-desktop-6
        .u-mb-mi
          AppImg(:srcset="[{ srcset: '{CDN_URL}/ventures/afad@2x.webp 2x, {CDN_URL}/ventures/afad.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/afad@2x.jpg 2x, {CDN_URL}/ventures/afad.jpg 1x', type: 'image/jpg' }]" ratio="3:2")
      .column.is-widescreen-5.is-desktop-6
        .content.u-mb-xs
          div(v-html="$t('content')")
        AppLink(to="https://www.behance.net/gallery/79515071/Afad-Brand-Identity-Design" :title="$t('cta')" class="button-link  " v-html="$t('cta')")


  .u-mb-md

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Afad",
    "pageDesc":"Afad is Baianat venture for alternative education. The platform provides learning tracks for children from different ages and in a variety of fields.",
    "mantra":"Afad alternative |learning platform.",
    "content":"<p>Finding authentic learning resources for children is a little challenging. With many options around, it’s hard to spot on the best way for rising up an aware child. The curriculum available in schools are mainly focused on the basic knowledge and skills like reading, writing, math, in addition to certain languages and few science classes. But developing children's skills requires more than a few classes and an exam full mark.</p><p>Dealing with education as a one size fits produces generations that lake an identity and with the issue of figuring out what they want. That’s where the role of alternative learning pops up.</p><p>When we were planning for Afad, we wanted to provide parents with a smart solution that helps them in figuring out what their children love and support it with a learning path that ensures their mastery. And for the kids, we wanted to provide an exciting and interactive learning experience.</p><p>Afad provides a website and an application which includes activities, games, videos or topic related resources so children can learn by doing. This is especially effective in today's age to children of ages between (2-12) years.</p><p>The platform will be operating in the MENA region with an identity that promotes the arabian culture and traditions and raises a generation that holds our ethics and morals.</p><p>Afad will be launched late 2019. But you can check the brand identity designed on Behance</p>",
    "cta":"Brand identity"
  },
  "ar": {
    "pageTitle":"أفاد",
    "pageDesc":"أفاد هو مشروع بيانات للتعليم البديل، من خلاله نوفر منصة تقدم مسارات تعليمية للأطفال من مختلف الأعمار وفي مجالات متنوعة.",
    "mantra":"أفاد منصة التعليم |التفاعلي البديل. ",
    "content":"<p>العثور على مواد تعليمية أصلية ومناسبة للأطفال أمر صعب بعض الشيء. وفي ظل وجود العديد من الخيارات يكون هناك الكثير من الحيرة حول تحديد المنصة المناسبة من أجل إنشاء طفل مدرك وواعي. </p><p>تركز المناهج الدراسية المتاحة في المدارس بشكل أساسي على تعليم المهارات الأساسية مثل الكتابة والقراءة والرياضيات بالإضافة إلى لغات محددة وعدد قليل من مناهج العلوم. لكننا نؤمن أن تطوير مهارات الطالب لا يقتصر فقط على بعض الفصول التعليمية والحصول على العلامة النهائية.</p><p>التعامل مع مسألة التعليم على أنها منهج واحد يناسب الجميع يخلق أجيال ضعيفة الهوية وفي نفس الوقت يكون لديهم صعوبة في تحديد ما يريدونه بالتحديد في المستقبل. وهنا يظهر دور التعليم البديل. </p><p>عندما فكرنا في أفاد كان هدفنا هو توفير حلًا ذكيًا للآباء يمكنهم من معرفة ما يفضله أولادهم ودعمه بمسار تعليمي يضمن إتقانهم. وبالنسبة للأطفال أردنا توفير تجربة تعليمية مثيرة وتفاعلية. </p><p>يوفر أفاد موقعًا على الويب وكذلك تطبيقًا يشمل أنشطة وألعاب ومقاطع فيديو ومصادر ذات صلة بالموضوع حتى يتمكن الأطفال من التعلم والتنفيذ في نفس الوقت. يعتبر هذا التعليم أكثر فاعلية بالنسبة للأطفال الذي تتراوح أعمارهم ما بين (2-12) سنة. </p><p>سوف تستهدف المنصة منطقة الشرق الأوسط وشمال إفريقيا بهوية تعزز الثقافة والتقاليد العربية وتربية جيل يحمل أخلاقنا. </p><p>سوف يتم إطلاق المنصة أواخر 2019. </p><p>لكن يمكنك التحقق من هوية العلامة التجارية المصممة على بيهانس</p>",
    "cta":"تصميم العلامة التجارية"
  }
}
</i18n>
